export function calculateMidpoint(start, end) {
  if(start && end) {
    const [lat1, lon1] = start;
  const [lat2, lon2] = end;

  // Convert latitude and longitude from degrees to radians
  const lat1Rad = lat1 * (Math.PI / 180);
  const lon1Rad = lon1 * (Math.PI / 180);
  const lat2Rad = lat2 * (Math.PI / 180);
  const lon2Rad = lon2 * (Math.PI / 180);

  // Compute midpoint in radians
  const dLon = lon2Rad - lon1Rad;

  const Bx = Math.cos(lat2Rad) * Math.cos(dLon);
  const By = Math.cos(lat2Rad) * Math.sin(dLon);

  const midLatRad = Math.atan2(
    Math.sin(lat1Rad) + Math.sin(lat2Rad),
    Math.sqrt((Math.cos(lat1Rad) + Bx) * (Math.cos(lat1Rad) + Bx) + By * By)
  );
  const midLonRad = lon1Rad + Math.atan2(By, Math.cos(lat1Rad) + Bx);

  // Convert midpoint back to degrees
  const midLat = midLatRad * (180 / Math.PI);
  const midLon = midLonRad * (180 / Math.PI);

  return [midLat, midLon];
  } else return
}
